import React, { useContext } from 'react'
import { Alert } from 'components'
import { Button } from 'components/Form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CreateBatteryStyles } from './Style'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { deleteAssessmentsFetch } from 'store/middlewares/assessment.crud'
import { Space } from 'styles/GlobalStyle'
import { AssessmentsContext } from './AssessmentsContext'

const DeleteAssessmentsAlert = (props) => {
    const { handleAlert = () => { } } = props
    const { setResetRowSelection, selectedAssessments, setSelectedAssessments, assessmentOptions } = useContext(AssessmentsContext)
    const queryClient = useQueryClient()

    const { mutateAsync: deleteAssessments, isPending } = useMutation({
        mutationFn: deleteAssessmentsFetch,
        onSuccess: () => {
            handleAlert(false)
            setResetRowSelection(true)
            setSelectedAssessments(null)
            queryClient.invalidateQueries({ queryKey: assessmentOptions.queryKey })
            toast(" המחיקה בוצעה בהצלחה", toastConfig)
        }
    })

    return (
        <Alert
            systemUI
            title={"מחיקת מבדקים"}
            footerActions={[]}
            handleAlert={() => handleAlert(false)}
            closeOnClick
        >
            <CreateBatteryStyles>
                <div>
                    <div>
                        {"המחיקה מסוכנת ולא ניתנת לשחזור"}
                    </div>
                    <div>
                        {"מחיקת המבדקים תמחק את החישובים שלהם, גרסאות שנוצרו ואת קובץ האודיו "}
                    </div>
                    <div>
                        {"באם המבדק מקושר לסוללה ומדובר במבדק האחרון הקיים לסוללה, הסוללה תמחק."}
                    </div>
                    <Space />
                    <Button
                        loading={isPending}
                        disabled={isPending}
                        action={() => deleteAssessments({ assessment_ids: selectedAssessments })}
                        color="thirdly"
                        label="אני בטוח רוצה למחוק"
                    />
                </div>
            </CreateBatteryStyles>
        </Alert>
    )
}

export default DeleteAssessmentsAlert